"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroupButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const avatar_group_button_style_1 = __importDefault(require("./avatar.group.button.style"));
const avatar_group_initials_1 = __importDefault(require("./avatar.group.initials"));
const avatar_group_clippath_1 = __importDefault(require("./avatar.group.clippath"));
const avatar_group_border_1 = __importDefault(require("./avatar.group.border"));
const avatar_group_colour_1 = __importDefault(require("./avatar.group.colour"));
const avatar_group_image_1 = __importDefault(require("./avatar.group.image"));
const avatar_group_overlay_1 = __importDefault(require("./avatar.group.overlay"));
const avatar_group_outline_1 = __importDefault(require("./avatar.group.outline"));
const icons_1 = require("../../icons");
class AvatarGroupButton extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.id = lodash_uniqueid_1.default('agb_');
        this.handleClick = event => {
            if (!this.props.disabled)
                this.props.onClick(event);
        };
        this.renderOverlay = () => {
            if (!this.props.overlay)
                return null;
            return jsx_runtime_1.jsx(avatar_group_overlay_1.default, { clipPathId: this.id, icon: jsx_runtime_1.jsx(icons_1.icons.Upload, {}, void 0) }, void 0);
        };
        this.renderAvatar = () => {
            const { classes, nth, initials, src } = this.props;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.avatar }, { children: src ? (jsx_runtime_1.jsx(avatar_group_image_1.default, { clipPathId: this.id, src: src }, void 0)) : (jsx_runtime_1.jsxs(react_1.Fragment, { children: [jsx_runtime_1.jsx(avatar_group_colour_1.default, { nth: nth, clipPathId: this.id }, void 0),
                        !!initials && jsx_runtime_1.jsx(avatar_group_initials_1.default, { initials: initials }, void 0)] }, void 0)) }), void 0));
        };
        this.render = () => {
            const { classes, size, label, disabled, buttonRef: ref } = this.props;
            const rootProps = {
                className: classes.root,
                onClick: this.handleClick,
                type: 'button',
                style: {
                    height: size,
                    width: size,
                    fontSize: size
                },
                disabled,
                ref,
                'aria-label': label
            };
            return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx(avatar_group_clippath_1.default, { clipPathId: this.id }, void 0),
                    jsx_runtime_1.jsx(avatar_group_outline_1.default, { clipPathId: this.id }, void 0),
                    jsx_runtime_1.jsx(avatar_group_border_1.default, { clipPathId: this.id }, void 0), this.renderAvatar(), this.renderOverlay()] }), void 0));
        };
    }
}
exports.AvatarGroupButton = AvatarGroupButton;
AvatarGroupButton.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    size: prop_types_1.default.number.isRequired,
    initials: prop_types_1.default.string,
    nth: prop_types_1.default.number,
    label: prop_types_1.default.string,
    src: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    buttonRef: prop_types_1.default.func,
    overlay: prop_types_1.default.bool
};
AvatarGroupButton.defaultProps = {
    initials: null,
    nth: null,
    label: null,
    src: null,
    disabled: false,
    buttonRef: () => { },
    overlay: false
};
exports.default = react_jss_1.default(avatar_group_button_style_1.default)(AvatarGroupButton);
//# sourceMappingURL=avatar.group.button.js.map